import type { AdditionalOptType } from '../filterTypes';

const OPT_TO_API_PARAM: Record<AdditionalOptType, string> = {
  requiresPhotos: 'requiresPhotos',
  requiresPrice: 'requiresPrice',
  forRentByOwner: 'forRentByOwner',
  hasOffers: 'hasOffers',
  acceptingApplications: 'acceptingApplications',
};

/**
 * Maps additional options to API boolean params.
 * ['requiresPhotos', 'forRentByOwner'] → { requiresPhotos: true, forRentByOwner: true }
 * [] → {}
 */
export function additionalOptsToApiParams(
  opts: Array<AdditionalOptType>,
): Record<string, boolean> {
  const params: Record<string, boolean> = {};
  for (const opt of opts) {
    const apiKey = OPT_TO_API_PARAM[opt];
    if (apiKey) {
      params[apiKey] = true;
    }
  }
  return params;
}
